export default __webpack_public_path__ + "assets/hospital-stroke-component.f830fa54.svg";